import { render, staticRenderFns } from "./GuestsPage.vue?vue&type=template&id=c7c08a0e&scoped=true"
import script from "./GuestsPage.vue?vue&type=script&lang=js"
export * from "./GuestsPage.vue?vue&type=script&lang=js"
import style0 from "./GuestsPage.vue?vue&type=style&index=0&id=c7c08a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c08a0e",
  null
  
)

export default component.exports